import { useTranslation } from "react-i18next";
import { Base } from "../text/Text.react";

export const StickyFloat = () => {
  const { t } = useTranslation(["pass"]);
  return (
    <div className="fixed right-0 bottom-14 z-50 flex flex-col items-end gap-2">
      <div className="group relative flex h-12 w-12 items-center justify-end overflow-hidden rounded-l-lg bg-[#004A78] text-white shadow-lg transition-all duration-300 hover:h-[400px] hover:w-[380px] hover:bg-[#004A78] md:hover:h-[260px] md:hover:w-[700px]">
        <div className="absolute left-0 flex flex-col whitespace-nowrap px-8 font-bold opacity-0 transition-opacity delay-100 group-hover:opacity-100">
          <Base className="text-wrap font-semibold text-sm text-white">
            {" "}
            {t("olkypass.general.info.dev_warning_title")}
          </Base>
          <div className="px-4">
            {" "}
            <ul className="list-disc">
              <li>
                {" "}
                <Base className="mt-2 text-wrap text-sm text-white">
                  {" "}
                  {t("olkypass.general.info.dev_warning_step")}
                </Base>
              </li>
              <li>
                {" "}
                <Base className="mt-2 text-wrap text-sm text-white">
                  {" "}
                  {t("olkypass.general.info.dev_warning_step1")}
                </Base>
              </li>{" "}
              <li>
                {" "}
                <Base className="mt-2 text-wrap text-sm text-white">
                  {" "}
                  {t("olkypass.general.info.dev_warning_step2")}
                </Base>
              </li>{" "}
              <li>
                {" "}
                <Base className="mt-2 text-wrap text-sm text-white">
                  {" "}
                  {t("olkypass.general.info.dev_warning_step3")}
                </Base>
              </li>
            </ul>
          </div>
        </div>

        <div className="absolute right-0 flex h-12 w-12 min-w-[3rem] items-center justify-center">
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
